import React, { Component } from "react";
import Painel from '../template/Painel'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, LinearScale } from 'chart.js';
import { Pie, Doughnut, Line } from 'react-chartjs-2';
import api from '../../services/api';

class Home extends Component {

    constructor(props){
        
        super(props);

        this.state = {
           pagamentos:'',
           vendas:'',
           faturamento:'',
           isCarregar:true,
        }
    }

    async componentDidMount() {
        const token         = sessionStorage.getItem('token');

        const dataAtual = new Date();
        const anoAtual = dataAtual.getFullYear();

        const usuario   = sessionStorage.getItem('usuario');
        
        if( !usuario ) {
            this.props.history.push('/');
        }

      
        const dataFilter = await api.get('/api/home', {
            headers: {
                'x-access-token':token,
            }
        })

        var vendas = dataFilter.data.vendas;
        var faturamento = dataFilter.data.faturamento;

       
        var faturaAtual = await faturamento.filter(fat => Number(fat.ano) == Number(anoAtual));
        var faturaAnterior = await faturamento.filter(fat => Number(fat.ano) == Number(anoAtual)-1);
        var mediaAtendimento = await dataFilter.data.media;

        let meiosPagamento = []
        let meiosPagamentoPago = []

        for (let index = 0; index < vendas.length; index++) {
            const venda = vendas[index];
            if(venda.pagamento){
                let idx = meiosPagamento.indexOf(venda.pagamento)
                if(idx < 0) {
                    meiosPagamento.push(venda.pagamento)
                    meiosPagamentoPago.push( venda.total )
                } else{
                    meiosPagamentoPago[idx] = meiosPagamentoPago[idx] + venda.total 
                }
            }
            
        }


        let media = ['ANTES DO PRAZO', 'EM ATRASO', 'NO PRAZO']
        let mediaValor = []

        for (let index = 0; index < mediaAtendimento.length; index++) {
            const item = mediaAtendimento[index];
            console.log(item)
            media.forEach(element => {                
                mediaValor.push(item[element])
            });
        }

        const medias = {
            labels: media,
            datasets: [
              {
                label: '# of Votes',
                data: mediaValor,
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                ],
                borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                ],
                borderWidth: 1,
              },
            ],
            
        };

        

        const pie = {
            labels: meiosPagamento,
            datasets: [
              {
                label: '# of Votes',
                data: meiosPagamentoPago,
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)',
                ],
                borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)',
                ],
                borderWidth: 1,
              },
            ],
            
        };

        const naoInicia     =  vendas.filter(fat => fat.status == 1).length
        const aprovadas     =  vendas.filter(fat => fat.status == 2).length;
        const producao      =  vendas.filter(fat => fat.status == 3).length;
        const pagos         =  vendas.filter(fat => fat.status == 5).length
     
        console.log(naoInicia, aprovadas, producao, pagos)
        const doughnut = {
            labels: ['Não Iniciadas','Pendentes','Em Produção','Entregues'],
            datasets: [
              {
                label: '# of Votes',
                data: [naoInicia, aprovadas, producao, pagos],
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)',
                ],
                borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)',
                ],
                borderWidth: 1,
              },
            ],
            
        };

        const options = {
            responsive: true,
            plugins: {
              legend: {
                position: 'top',
              },
              title: {
                display: true,
                text: 'Chart.js Line Chart',
              },
            },
        };

        const labels = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
        const meses  = [    1,     2,     3,     4,     5,     6,     7,     8,     9,    10,    11,    12];
        const data = {
            labels,
            datasets: [
                {
              
                    label: 'ANO ' + anoAtual,
                    data: meses.map(mes => faturaAtual.filter(fat => fat.mes == mes).length ?faturaAtual.filter(fat => fat.mes == mes)[0].total : 0  ),
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
               
                },
                {
                    label: 'ANO ' + ( anoAtual-1),
                    data: meses.map(mes => faturaAnterior.filter(fat => fat.mes == mes).length ?faturaAnterior.filter(fat => fat.mes == mes)[0].total : 0  ),
                    borderColor: 'rgb(53, 162, 235)',
                    backgroundColor: 'rgba(53, 162, 235, 0.5)',
                  },
            ],
        };
        
        
        this.setState({
            isCarregar:false,
            pagamentos:pie,
            vendas: doughnut,
            medias: medias,
            faturamento: [options, data]
        })
    }

    render() {

        
        return  (
                <div className="content-wrapper">
                    <section className="content-header">        
                        <Painel />  
                    </section>
                    <section className="content">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="card card-primary">                                    
                                        <div class="card-header">
                                            <h3 class="card-title">Vendas Por Status de Pedido</h3>
                                            <div class="card-tools">
                                                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                                    <i class="fas fa-minus"></i>
                                                </button>
                                                <button type="button" class="btn btn-tool" data-card-widget="remove">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="chart">
                                                <Doughnut data={this.state.vendas} />
                                            </div>
                                        </div>
                                        {   this.state.isCarregar ? 
                                            <div class="overlay d-flex justify-content-center align-items-center">
                                                <i class="fas fa-2x fa-sync fa-spin"></i>
                                                </div>
                                            : ''
                                        }
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card card-primary">                                    
                                        <div class="card-header">
                                            <h3 class="card-title">Vendas Por Meio de Pagamento</h3>
                                            <div class="card-tools">
                                                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                                    <i class="fas fa-minus"></i>
                                                </button>
                                                <button type="button" class="btn btn-tool" data-card-widget="remove">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="chart">
                                                <Pie data={this.state.pagamentos} />
                                                
                                            </div>
                                            
                                        </div>
                                        {   this.state.isCarregar ? 
                                            <div class="overlay d-flex justify-content-center align-items-center">
                                                <i class="fas fa-2x fa-sync fa-spin"></i>
                                                </div>
                                            : ''
                                        }
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card card-primary">                                    
                                        <div class="card-header">
                                            <h3 class="card-title">Faturamento Anual X Ano Anterior</h3>
                                            <div class="card-tools">
                                                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                                    <i class="fas fa-minus"></i>
                                                </button>
                                                <button type="button" class="btn btn-tool" data-card-widget="remove">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="chart">
                                                <Line options={this.state.faturamento[0]} data={this.state.faturamento[1]} />                                                
                                            </div>
                                            
                                        </div>
                                        {   this.state.isCarregar ? 
                                            <div class="overlay d-flex justify-content-center align-items-center">
                                                <i class="fas fa-2x fa-sync fa-spin"></i>
                                                </div>
                                            : ''
                                        }
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card card-primary">                                    
                                        <div class="card-header">
                                            <h3 class="card-title">% de Entrega dos serviços</h3>
                                            <div class="card-tools">
                                                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                                    <i class="fas fa-minus"></i>
                                                </button>
                                                <button type="button" class="btn btn-tool" data-card-widget="remove">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="chart">
                                                <Pie data={this.state.medias} />
                                                
                                            </div>
                                            
                                        </div>
                                        {   this.state.isCarregar ? 
                                            <div class="overlay d-flex justify-content-center align-items-center">
                                                <i class="fas fa-2x fa-sync fa-spin"></i>
                                                </div>
                                            : ''
                                        }
                                    </div>
                                </div>

                                
                            </div>
                        </div>
                    </section>
                </div>
        );
    
    }
}


export default Home;